import React, { PureComponent } from 'react';
import ClassNames from 'classnames';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SaleAction } from '../../store/actions';

class CashMemo extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  render() {
    return (
      <div className="h5 text-uppercase">
        <div className="row">
          <div className="col">
            <div style={{ height: '11rem' }} />
            <p className="h3 text-center">
              <u>CASH MEMO</u>
            </p>
            <p>
              ID: {this.props.sale?.id}
              <br />
              DATE: {this.props.sale?.sold_at}
              <br />
              NAME: {this.props.sale?.customer?.name}
              <br />
              {this.props.sale?.customer?.gender === 'female' ? 'D/O': 'S/O'}:
              {' '}
              {this.props.sale?.customer?.father_name}
              <br />
              ADDRESS: {this.props.sale?.customer?.address}
              <br />
              MOBILE: {this.props.sale?.customer?.mobile_number}
            </p>
            <p className="mt-5 text-center">
              <u>
                PLEASE RECEIVED UNDER MENTIONED VEHICLE AND SIGN FOR RECEIPT
              </u>
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <table
              className={ClassNames('table table-bordered my-5', {
                'table-sm': !!this.props.sale?.is_due,
              })}
            >
              <thead>
                <tr>
                  <th width="60%">
                    <p className="mb-0">DESCRIPTION OF VEHICLE</p>
                  </th>
                  <th width="20%" />
                  <th className="text-right" width="20%">
                    <p className="mb-0">AMOUNT</p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <p className="mb-0">
                      {this.props.sale?.purchase?.vehicle?.model}{' '}
                      {this.props.sale?.purchase?.vehicle?.class}
                    </p>
                  </td>
                  <td />
                  <td className="text-right">
                    <p className="mb-0">{this.props.sale?.price}</p>
                  </td>
                </tr>
                {!!this.props.sale?.is_due && (
                  <>
                    <tr>
                      <td />
                      <td className="text-right">
                        <p className="mb-0">ADVANCE</p>
                      </td>
                      <td className="text-right">
                        <p className="mb-0">{this.props.sale?.advance}</p>
                      </td>
                    </tr>
                    <tr>
                      <td />
                      <td className="text-right">
                        <p className="mb-0">DUE</p>
                      </td>
                      <td className="text-right">
                        <p className="mb-0">{this.props.sale?.initial_due}</p>
                      </td>
                    </tr>
                  </>
                )}
                <tr>
                  <td>
                    <p className="mb-0">
                      CHASSIS NO: {this.props.sale?.purchase?.chassis_number}
                    </p>
                  </td>
                  <td />
                  <td />
                </tr>
                <tr>
                  <td>
                    <p className="mb-0">
                      ENGINE NO: {this.props.sale?.purchase?.engine_number}
                    </p>
                  </td>
                  <td />
                  <td />
                </tr>
                <tr>
                  <td>
                    <p className="mb-0">
                      KEY NO: {this.props.sale?.purchase?.key_number}
                    </p>
                  </td>
                  <td />
                  <td />
                </tr>
                <tr>
                  <td>
                    <p className="mb-0">
                      COLOUR: {this.props.sale?.purchase?.color?.name}
                    </p>
                  </td>
                  <td />
                  <td />
                </tr>
                <tr>
                  <td />
                  <td className="text-right">
                    <p className="mb-0">TOTAL</p>
                  </td>
                  <td className="text-right">
                    <p className="mb-0">{this.props.sale?.price}</p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="row">
          <div className="col">
            <p className="mb-5">
              <u>TAKA IN WORDS:</u> {this.props.sale?.price_in_words}
            </p>
            <p className="text-center">
              REMARKS:
              <span dangerouslySetInnerHTML={{ __html: '&nbsp&nbsp&nbsp' }} />
              1. TOOLS
              <span dangerouslySetInnerHTML={{ __html: '&nbsp&nbsp&nbsp' }} />
              2. SERVICE BOOK
            </p>
            <p className="text-center">
              CHECKED FOUND CORRECT AND RECEIVED THE ABOVE MENTIONED IN GOOD
              CONDITION.
            </p>
            <p className="d-flex justify-content-between pt-3 mt-5">
              <span className="border-dark border-top">CUSTOMER SIGNATURE</span>
              <span className="border-dark border-top">
                AUTHORIZED SIGNATURE
              </span>
            </p>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CashMemo);
